import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: none;
        max-height: none;
        min-width: 400px;
    `,
};
